import { FigmaExporterProcessedStylesSchema } from "./figma-exporter-styles";
import { z } from "zod";
export const textSpanSchema = z.object({
    text: z.string(),
    styles: FigmaExporterProcessedStylesSchema.partial(),
});
export const textParagraphBlockSchema = z.object({
    type: z.literal("paragraph"),
    spans: z.array(textSpanSchema),
});
export const textListItemSchema = z.lazy(() => z.object({
    spans: z.array(textSpanSchema),
    children: z.array(textBlockSchema),
}));
export const textListBlockSchema = z.object({
    type: z.literal("list"),
    kind: z.union([z.literal("ordered"), z.literal("unordered")]),
    items: z.array(textListItemSchema),
});
export const textBlockSchema = z.lazy(() => z.union([textParagraphBlockSchema, textListBlockSchema]));
